<style scoped>
    .editor-wrapper{
        max-width: 800px;
        margin: 0 auto;
    }
    .pop-tip-content{
        width: 240px;
    }
    .form-header{
        border-bottom: 1px solid #dddee1;
        margin-bottom: 8px;
    }
    .ivu-form-item{
        margin-bottom: 5px;
    }
    .form-header .ivu-form-item{
        margin-bottom: 0;
    }
</style>
<style lang="less" scoped>
    .radio_content {
      display: inline-block;
      margin: 0 10px;
      .name {
        display: inline-block;
        width: 50px;
      }
    }
</style>
<template>
  <div>
    <Modal
      v-model="config.modal"
      title="添加/编辑合同"
      fullscreen
      width="800"
      :loading="config.loading"
      ok-text="保存"
      @on-ok="setContractOK"
    >
      <Form
        v-show="!loading"
        class="editor-wrapper"
        :label-width="90"
      >
        <div class="fill-info">
          <Row class="form-header">
            <i-col span="6">
              <FormItem 
                :label-width="100"
                label="填制时间"
              >
                <span class="color-grey">{{ getFillTime(edit_contract) }}</span>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem 
                :label-width="100"
                label="申请人"
              >
                <CustomerSelector
                  v-model="edit_contract.apply_user_id"
                  type="text"
                  width="400"
                  :disabled="!can_edit"
                  @on-change="setApplyUser"
                >
                  <span v-if="edit_contract.apply_user">{{ edit_contract.apply_user }}</span>
                  <span
                    v-else
                    class="color-grey"
                  >选择</span>
                </CustomerSelector>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem 
                :label-width="100"
                label="填制人"
              >
                <span class="color-grey">{{ edit_contract.fill_user }}</span>
              </FormItem>
            </i-col>
            <i-col span="6">
              <FormItem 
                :label-width="100"
                label="编号"
              >
                <span
                  v-if="edit_contract.uid"
                  class="color-disabled"
                >{{ edit_contract.uid }}</span>
                <span
                  v-else
                  class="color-disabled"
                >保存后自动生成</span>
              </FormItem>
            </i-col>
          </Row>
        </div>
        <!-- <div class="hr"></div> -->
        <FormItem 
          :label-width="100"
          label="合同名称"
        >
          <i-input
            v-model="edit_contract.name"
            placeholder="简单描述合同内容: 采购xx/委托创作/xx服务等"
          />
        </FormItem>
        <Row :gutter="4">
          <i-col span="8">
            <FormItem 
              :label-width="100"
              label="合同类型"
            >
              <Select
                v-model="edit_contract.contract_type_id"
                placeholder="合同类型"
                filterable
              >
                <Option
                  v-for="(ct,index) in (contract_types||[]).filter(item=>item.balance_type==='expense'&&item.relation_type.includes('stock'))"
                  :key="index"
                  :value="ct.id"
                >
                  {{ ct.sub_type }}({{ ct.type_code }})
                </Option>
              </Select>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem 
              :label-width="100"
              label="选择公司"
            >
              <Select
                v-model="edit_contract.company_id"
                transfer
                placeholder="选择公司: 根据业务归属"
              >
                <Option
                  v-for="company in companies"
                  :key="company.id"
                  :value="company.id"
                >
                  {{ company.name }}
                </Option>
              </Select>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem 
              :label-width="100"
              label="选择团队"
            >
              <Select
                v-model="edit_contract.team_id"
                transfer
                placeholder="选择团队"
                filterable
              >
                <Option
                  v-for="team in teams"
                  v-show="edit_contract.id || (!edit_contract.id && !team.del)"
                  :key="team.id"
                  :value="team.id"
                  :disabled="team.del"
                >
                  {{ team.name }}
                </Option>
              </Select>
            </FormItem>
          </i-col>
        </Row>
        <FormItem 
          :label-width="100"
          label="法务审批人"
        >
          <RadioGroup
            v-model="edit_contract.legal_audit_user_id"
            vertical
            @on-change="legalAuditUserChange"
          >
            <Radio
              v-for="item in person_list"
              :key="item.id"
              :label="item.id"
              :disabled="(!item.active)"
              @click="edit_contract.legal_audit_user=item.account"
            >
              <span class="radio_content">
                <span class="name">
                  {{ item.account }}
                </span>
                <span v-show="item.active">
                  <Tag color="blue">正在处理的数量：{{ item.pending }}</Tag>
                  <Tag color="blue">平均处理时长(天)：{{ item.avg_time }}</Tag>
                </span>
                <span v-show="(!item.active)">
                  <Tag color="warning">暂时无法提供服务</Tag>
                </span>
              </span>
            </Radio>
          </RadioGroup>
        </FormItem>
        <FormItem 
          :label-width="100"
          label="框架合同"
        >
          <Checkbox v-model="edit_contract.is_framework">
            如果为框架合同或协议，请勾选
          </Checkbox>
        </FormItem>
        <FormItem 
          :label-width="100"
          label="充值类合同"
        >
          <Checkbox v-model="edit_contract.is_recharge">
            如果为充值类合同，请勾选
          </Checkbox>
        </FormItem>
        <FormItem 
          :label-width="100"
          label="版权合同"
        >
          <Checkbox v-model="edit_contract.copyright_related">
            如果为版权类合同，请勾选
          </Checkbox>
        </FormItem>
        <FormItem
          v-if="is_financer"
          :label-width="100"
          label="虚拟合同"
        >
          <Checkbox v-model="edit_contract.is_virtual">
            用于关联无合同费用
          </Checkbox>
        </FormItem>
        <FormItem
          v-if="is_financer"
          :label-width="100"
          label="需要拆费用"
        >
          <Checkbox v-model="edit_contract.need_split_expense">
            合同/付款/发票提交时，团队为中后台团队，计提费用时，拆分到实际使用团队
          </Checkbox>
        </FormItem>
        <!-- 
          下拉

          
         -->
        <Row>
          <i-col span="8">
            <FormItem
              :label-width="100"
              label="生效日期"
            >
              <DatePicker
                v-model="edit_contract.contract_start"
                type="date"
                placeholder="生效日期"
                @on-change="function(date){edit_contract.contract_start = date}"
              />
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem
              :label-width="100"
              label="终止日期"
            >
              <DatePicker
                v-model="edit_contract.contract_end"
                type="date"
                placeholder="终止日期"
                @on-change="function(date){edit_contract.contract_end = date}"
              />
            </FormItem>
          </i-col>
        </Row>
        <!-- <div class="line color-error">
                    <p>选择[公司]时请根据业务归属选择, 而不是员工签约.</p>
                </div> -->
        <div>
          <FormItem 
            :label-width="100"
            label="供应商类型"
          >
            <RadioGroup
              v-model="edit_contract.payee_company_type"
              size="small"
            >
              <Radio
                :label="0"
                :disabled="is_personal_contract"
              >
                <span>个人</span>
              </Radio>
              <Radio
                :label="1"
                :disabled="is_personal_contract"
              >
                <span>公司</span>
              </Radio>
            </RadioGroup>
          </FormItem>
        </div>
        <div>
          <Row
            v-show="edit_contract.payee_company_type === 0"
            :gutter="4"
          >
            <i-col span="8">
              <FormItem
                :label-width="100"
                label="个人姓名"
              >
                <PayeeCompanySelector
                  ref="personSelector"
                  type="person"
                  :hide-search-bar="true"
                  @on-change="setPayeeCompany"
                >
                  <i-input
                    v-model="edit_contract.payee_company"
                    placeholder="个人姓名"
                    @on-change="searchPayeeCompanyPerson"
                    @on-focus="searchPayeeCompanyPerson"
                  />
                </PayeeCompanySelector>
              </FormItem>
            </i-col>
            <i-col span="8">
              <FormItem
                :label-width="100"
                label="个人证件号"
              >
                <i-input
                  v-model="edit_contract.payee_id_number"
                  placeholder="身份证/护照号"
                />
              </FormItem>
            </i-col>
          </Row>
          <Row
            v-show="edit_contract.payee_company_type === 1"
            :gutter="4"
          >
            <i-col span="12">
              <FormItem
                :label-width="100"
                label="公司名称"
              >
                <PayeeCompanySelector
                  ref="payeeCompanySelector"
                  type="company"
                  :hide-search-bar="true"
                  @on-change="setPayeeCompany"
                >
                  <i-input
                    v-model="edit_contract.payee_company"
                    placeholder="公司名称"
                    @on-change="searchPayeeCompany"
                    @on-focus="searchPayeeCompany"
                  />
                </PayeeCompanySelector>
              </FormItem>
            </i-col>
          </Row>
        </div>
        <div>
          <Row :gutter="4">
            <i-col span="12">
              <FormItem
                :label-width="100"
                label="合同总价"
              >
                <i-input
                  v-model="edit_contract.total_price"
                  number
                  placeholder="外币请折合为人民币"
                />
              </FormItem>
            </i-col>
            <i-col span="6">
              <Button
                v-if="with_stock"
                @click="setStockTotalPriceToContractTotalPrice"
              >
                设为存货总价
              </Button>
            </i-col>
          </Row>
          <Row>
            <i-col span="12">
              <FormItem
                :label-width="100"
                label="预计每月消耗"
              >
                <i-input
                  v-model="edit_contract.per_month_price"
                  type="number"
                  @on-change="numberChange(edit_contract.per_month_price,edit_contract,'per_month_price')"
                />
              </FormItem>
            </i-col>
          </Row> 
        </div>
        <div v-if="checkDis">
          <Divider>核算组</Divider>
          <Row :gutter="4">
            <i-col span="12">
              <FormItem
                :label-width="100"
                label="消耗计划"
              >
                <Checkbox v-model="edit_contract.has_consume_schedule" />
              </FormItem>
            </i-col>
            <i-col
              v-if="edit_contract.has_consume_schedule"
              span="24"
            >
              <Row :gutter="4">
                <i-col span="12">
                  <FormItem
                    :label-width="100"
                    label="起止时间"
                  >
                    <DatePicker
                      :value="[edit_contract.consume_schedule.start_date,edit_contract.consume_schedule.end_date]"
                      type="daterange"
                      placeholder="请选择时间"
                      @on-change="handleChangeDate"
                    />
                  </FormItem>
                </i-col>
                <i-col span="8">
                  <FormItem
                    label="每月消耗金额"
                    ::label-width="100"
                  >
                    <i-input
                      v-model="edit_contract.consume_schedule.per_month"
                      type="number"
                      placeholder="外币请折合为人民币"
                      @on-change="numberChange(edit_contract.consume_schedule.per_month,edit_contract,'consume_schedule.per_month')"
                    />
                  </FormItem>
                </i-col>
              </Row>
            </i-col>
          </Row>
          <Row :gutter="4">
            <i-col span="12">
              <FormItem
                :label-width="100"
                label="账单生成方式"
              >
                <Select
                  v-model="edit_contract.bill_generate_type"
                  filterable
                >
                  <Option
                    v-for="(item,index) in bill_generate_type_lists"
                    :key="index"
                    :value="item.value"
                    :label="item.label"
                  />
                </Select>
              </FormItem>
            </i-col>
            <i-col span="6">
              <Button
                :loading="set_bill_generate_type_loading"
                @click="setBillGenerateType"
              >
                匹配账单生成方式
              </Button>
            </i-col>
          </Row>
          <Row
            v-if="'self_submit'===edit_contract.bill_generate_type"
            :gutter="4"
          >
            <i-col span="12">
              <FormItem
                :label-width="100"
                label="账单来源"
              >
                <Select
                  v-model="edit_contract.bill_provider"
                  clearable
                >
                  <Option
                    v-for="(item,index) in bill_provider_types"
                    :key="index"
                    :value="item.value"
                    :label="item.label"
                  />
                </Select>
              </FormItem>
            </i-col>
          </Row>
          <Divider />
        </div>
        <Row v-show="with_stock">
          <i-col span="8">
            <FormItem
              :label-width="100"
              label="订单类型"
            >
              <Select
                v-model="edit_contract.bill_type"
                placeholder="订单类型"
              >
                <Option value="Standard">
                  标准订单
                </Option>
                <Option value="OutSourcing">
                  委外订单
                </Option>
              </Select>
            </FormItem>
          </i-col>
        </Row>
        <div v-show="with_stock">
          <div v-if="!edit_contract.contract_stocks.length">
            <Button
              type="primary"
              icon="md-add"
              @click="addContractStock"
            >
              添加存货
            </Button>
          </div>
          <table class="mis-table">
            <thead>
              <tr>
                <td>存货编码</td>
                <td>存货名称</td>
                <td>条码/ISBN</td>
                <td width="120">
                  采购数量
                </td>
                <td
                  v-if="is_show_stock_in_selector"
                  width="80"
                >
                  入库类型
                </td>
                <td width="90">
                  采购单价
                </td>
                <td width="115">
                  总价(点击 <Icon type="ios-calculator" /> 计算)
                </td>
                <td width="124">
                  预计到货时间
                </td>
                <td width="70">
                  操作
                </td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(contract_stock, index) in edit_contract.contract_stocks"
                :key="index"
              >
                <td>
                  <div>{{ getContractStock(contract_stock.stock_id).uid }}</div>
                  <StockQty
                    v-if="contract_stock.stock_id"
                    :stock_id="contract_stock.stock_id"
                  />
                </td>
                <td>
                  <Poptip
                    class="long-poptip"
                    transfer
                    placement="bottom"
                  >
                    <div class="pointer color-info">
                      <span v-if="contract_stock.stock_id">{{ getContractStock(contract_stock.stock_id).name }}</span>
                      <span v-else>选择存货</span>
                    </div>
                    <div
                      slot="content"
                      class="pop-tip-content"
                    >
                      <i-input
                        v-model.trim="search_stock_text"
                        placeholder="搜索存货"
                        @on-enter="queryStock"
                      >
                        <Button
                          slot="append"
                          icon="ios-search"
                          :loading="search_stock_loading"
                          @click="queryStock"
                        />
                      </i-input>
                      <div class="hr" />
                      <Button
                        v-for="item in search_stock_results"
                        :key="item.key"
                        :disabled="item.status===1"
                        long
                        size="small"
                        style="margin-bottom: 5px;"
                        @click="setContractStock(contract_stock, item)"
                      >
                        <span>{{ item.uid }} - {{ item.name }}</span>
                        <span v-show="item.status===status_hash.clear_inventory.value">[清库存]</span>
                      </Button>
                    </div>
                  </Poptip>
                </td>
                <td>{{ getContractStock(contract_stock.stock_id).barcode || '-' }}</td>
                <td>
                  <i-input
                    v-model="contract_stock.qty"
                    size="small"
                  />
                  <div>
                    <ContractStockWarehouse :contract_stock="contract_stock" />
                  </div>
                  <ViewerItem
                    v-if="contract_stock.stock_id"
                    :model_id="contract_stock.stock_id"
                    type="StockCalculator"
                    show_type="drawer"
                    :tip="false"
                    class="link"
                  >
                    最佳采购量计算
                  </ViewerItem>
                </td>
                <td v-if="is_show_stock_in_selector">
                  <Select
                    v-model="contract_stock.stock_in_type"
                    size="small"
                  >
                    <Option value="none">
                      无需入库
                    </Option>
                    <Option value="need">
                      需要入库
                    </Option>
                  </Select>
                </td>
                <td>
                  <i-input
                    v-model="contract_stock.unit_price"
                    size="small"
                  />
                </td>
                <td>
                  <i-input
                    v-model="contract_stock.total_price"
                    size="small"
                    icon="ios-calculator"
                    @on-click="calcContractStockPrice(contract_stock)"
                  />
                  <!--<span>￥ {{contract_stock.total_price}}</span>-->
                </td>
                <td>
                  <DatePicker
                    type="date"
                    size="small"
                    placeholder="到货时间..."
                    :value="contract_stock.estimate_arrival_time"
                    style="width: 110px"
                    @on-change="function(date){contract_stock.estimate_arrival_time = date}"
                  />
                </td>
                <td>
                  <Button
                    v-if="isLastContractStock(index)"
                    size="small"
                    shape="circle"
                    icon="md-add"
                    @click="addContractStock"
                  />
                  <Button
                    size="small"
                    shape="circle"
                    icon="md-close"
                    @click="deleteContractStock(contract_stock, index)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="line">
          <FormItem
            :label-width="100"
            label="合同附件"
          >
            <EditAttachments
              :files="edit_contract.bfiles"
              model_type="Contract"
              :model_id="edit_contract.id"
            />
            <FileUploader @uploaded="attachmentUploaded" />
            <span class="color-error">为保证兼容性及文档可编辑性，请上传office系列的文档(Word, Excel, PPT)</span>
          </FormItem>
        </div>
        <div>
          <!--<FormItem label="关联主合同">
                        <ParentContractSearch :parent_contract="edit_contract.parent"></ParentContractSearch>
                    </FormItem>-->
          <FormItem
            :label-width="100"
            label="关联合同"
          >
            <table
              v-if="edit_contract.link_contracts && edit_contract.link_contracts.length"
              class="mis-table"
            >
              <tr>
                <th width="180">
                  合同编号
                </th>
                <th>合同名称</th>
                <th>操作</th>
              </tr>
              <tr
                v-for="(contract, index) in edit_contract.link_contracts"
                :key="contract.id"
              >
                <td>
                  <ContractSelector
                    size="small"
                    :clearable="false"
                    @on-change="setLinkContract(index, ...arguments)"
                  >
                    <span v-if="contract.id">{{ contract.uid }}</span>
                    <span
                      v-else
                      class="color-grey"
                    >请选择合同</span>
                  </ContractSelector>
                </td>
                <td>{{ contract.name || '-' }}</td>
                <td>
                  <Button
                    v-if="index === edit_contract.link_contracts.length - 1"
                    shape="circle"
                    size="small"
                    type="primary"
                    icon="md-add"
                    @click="setLinkContract(edit_contract.link_contracts.length, {})"
                  />
                  <Poptip
                    confirm
                    title="你确定要取消关联吗?"
                    @on-ok="delLinkContract(index)"
                  >
                    <Button
                      shape="circle"
                      size="small"
                      type="warning"
                      icon="md-close"
                    />
                  </Poptip>
                </td>
              </tr>
            </table>
            <Button
              v-else
              size="small"
              icon="md-add"
              @click="setLinkContract(0, {})"
            >
              添加关联合同
            </Button>
            <Spin
              v-if="deleting_link_contract"
              fix
            />
          </FormItem>
        </div>
        <div>
          <FormItem label="备注">
            <RichText
              :config="rich_text_config"
              :text.sync="edit_contract.desc"
            />
          </FormItem>
        </div>
      </Form>
      <Spin
        v-show="loading"
        fix
      />
    </Modal>

    <Modal
      v-model="store_file_config.modal"
      title="合同归档"
      width="700"
      :loading="store_file_config.loading"
      ok-text="确定"
      @on-ok="storeFileOK"
    >
      <div class="line">
        <span
          v-for="file in edit_contract.files"
          :key="file.id"
          class="attachment"
          @click="confirmDeleteFile(file)"
        >
          {{ file.name }}
        </span>
        <FileUploader @uploaded="fileUploaded">
          上传归档文件
        </FileUploader>
        <Spin
          v-show="loading"
          fix
        />
      </div>
    </Modal>
  </div>
</template>
<script>
  import CustomerSelector from '../../components/customer/selector';
  import ParentContractSearch from '../../fin/components/parent_contract_search';
  import ContractSelector from './selector';
  import PayeeCompanySelector from '../../components/payee_company/selector';
  import ContractStockWarehouse from './contract_stock_warehouse';
  import FileUploader from '../../components/file/uploader';
  import EditAttachments from '../../components/file/edit_attachments';
  import StockQty from '../../stock/components/stock_qty';
  import ViewerItem from '../../components/viewer/item';
  import ContractUtil from '../libs/util';
  import FlowUtil from '../../../libs/flow_util';
  import {status_hash} from '@/views/business/fields.js'
  import { getLegalAuditUsersApi, getBillGenerateTypeApi } from './contract_editor_service'
  import { bill_generate_type_lists, bill_provider_types } from '../libs/fields'
  import {mapGetters } from "vuex";
  export default {
    components: { CustomerSelector, ParentContractSearch, PayeeCompanySelector, ContractStockWarehouse,
                  ContractSelector, StockQty, FileUploader, EditAttachments, ViewerItem},
    props: {
      contract: {
        type: Object
      },
      contract_types: {
        type: Array,
        default() {
          return [];
        }
      },
      contract_type_hash: {
        type: Object,
        default() {
          return {};
        }
      },
    },
    data() {
      this.status_hash = status_hash
      this.old_contract = ''
      return {
        person_list:[],
        loading: false,
        set_bill_generate_type_loading:false,
        deleting_link_contract: false,
        config: {
          modal: false,
          loading: true
        },
        rich_text_config: {
          show: true,
          fixed: false,
          show_handler: false,
          width: '100%',
          title: '备注:'
        },
        new_contract: {
          bill_provider: '',
          name: '',
          uid: '',
          parent_id: 0,
          contract_type_id: 0,
          bill_type: '',
          apply_user: '',
          apply_user_id: 0,
          fill_user: '',
          fill_user_id: 0,
          company_id: '',
          team_id: '',
          payee_company: '',
          payee_company_id: 0,
          payee_company_type: 0,
          payee_id_number: '',
          total_price: '',
          is_closed: false,
          copyright_related: false,
          need_split_expense: false,
          is_framework: false,
          is_recharge: false,
          is_virtual: false,
          contract_start: '',
          contract_end: '',
          desc: '',
          contract_stocks: [],
          bfiles: [],
          parent: {id: 0, name: '', uid: ''},
          contracts: [],
          link_contracts: [],
          bill_generate_type: null, // 账单生成方式
          per_month_price: null, // 平均每月消耗
          has_consume_schedule: false, // 是否有消耗计划（不用传给后端）
          consume_schedule: { // 消耗计划
            start_date:  "", // 开始时间
            end_date: "", // 终止时间
            per_month: "" // 平均每月消耗
          }
        },
        new_contract_stock: {
          contract_id: 0,
          stock_id: 0,
          stock_in_type: '',
          qty: 0,
          unit_price: 0,
          total_price: 0,
          estimate_arrival_time: '',
          contract_stock_warehouses: []
        },
        edit_contract: {
          company_id: '',
          contract_type_id: '',
          contract_stocks: [],
          desc: '', parent: {},
          legal_audit_user_id:'',
          legal_audit_user:''
        },
        with_stock: false,
        stocks_hash: {},
        is_personal_contract: false,
        search_fill_user_text: '',
        search_fill_user_result : [],
        search_payee_user_text: '',
        search_payee_user_result: [],
        search_contract_type_text: '',
        contract_stocks: [],
        search_stock_text: '',
        search_stock_loading: false,
        search_stock_results: [],
        store_file_config: {
          modal: false,
          loading: true
        },
      }
    },
    computed: {
      checkDis() {
        const current_hash = this.$store.state.hash_authority || {}
        return current_hash.business_accounting_contract
      },
      bill_generate_type_lists:() => bill_generate_type_lists,
      bill_provider_types: () => bill_provider_types,
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      is_financer() {
        return this.$store.getters.is_financer;
      },
      search_contract_type_result() {
        const ret = [];
        const search = this.search_contract_type_text;
        this.contract_types.forEach((type) => {
          if (search) {
            if (type.name.indexOf(search) > -1) {
              ret.push(type);
            }
          } else {
            ret.push(type);
          }
        });
        return ret;
      },
      ...mapGetters({
        companies: 'async/companies',
        companies_hash: 'async/companies_hash',
        teams: 'async/root_teams',
        teams_hash: 'async/root_teams_hash',
      }),
      is_show_stock_in_selector() {
        // 委外订单, 需选择入库类型
        const groups = this.cur_customer.groups;
        const is_fin_user = groups && groups.includes('GROUP_FIN');
        const is_mall_user = groups && groups.includes('GROUP_MALL');
        return this.edit_contract.bill_type === 'OutSourcing' && (is_fin_user || is_mall_user);
      },
      can_edit() {
        return FlowUtil.inEditNode(this.edit_contract);
      }
    },
    watch: {
      'config.modal'(data) {
        if (data) {
          getLegalAuditUsersApi.call(this, () => { this.config.modal = false }).then(data => {
            this.person_list = data.users
          })
        }
      },
      cur_customer(customer) {
        this.setFillUser(customer);
        this.setApplyUser(this.cur_customer);
      },
      'edit_contract.contract_type_id'(id) {
        //if(this.init_editor) return;
        const contract_type = this.getContractType(id);
        if (contract_type.with_stock) {
          this.with_stock = true;
          if (this.edit_contract.contract_stocks.length === 0) {
            this.edit_contract.contract_stocks.push(this.$util.clone(this.new_contract_stock));
          }
        } else {
          this.with_stock = !!this.edit_contract.contract_stocks.length;
        }
        if (contract_type.name && contract_type.name.indexOf('个人') > -1) {
          this.is_personal_contract = true;
          this.edit_contract.payee_company_type = 0;
        } else {
          this.is_personal_contract = false;
        }
      },
      'edit_contract.contract_stocks'() {
        if (this.init_editor) return;
        if (this.edit_contract.contract_stocks.length === 0) {
          const contract_type = this.getContractType(this.edit_contract.contract_type_id);
          this.with_stock = contract_type.with_stock;
        }
      },
      'edit_contract.payee_company_type'() {
        if (this.init_editor) return;
        this.edit_contract.payee_company = '';
        this.edit_contract.payee_company_id = 0;
      },
    },
    mounted() {
      this.init();
    },
    methods: {
      numberChange(data, target, keys) {
        const digt_index = data.indexOf('.')
        if (digt_index === -1) {
          return 
        }
        setTimeout(() => {
          keys = keys.split('.')
          keys.reduce((total, key, currentIndex) => {
            if (currentIndex === keys.length - 1) {
              data = data.slice(0, digt_index + 3)
              total[key] = data
              return 
            }
            return total[key]
          }, target)
        }, 50)
      },
      handleChangeDate([start_date, end_date]) {
        const consume_schedule = this.edit_contract.consume_schedule
        consume_schedule.start_date = start_date
        consume_schedule.end_date = end_date
      },
      setBillGenerateType() {
        this.set_bill_generate_type_loading = true
        const { contract_type_id, is_framework, is_recharge, total_price, per_month_price, has_consume_schedule } = this.edit_contract
        const params = { contract_type_id, is_framework, is_recharge, total_price, per_month_price, has_consume_schedule }
        getBillGenerateTypeApi(params).then((data) => {
          this.edit_contract.bill_generate_type = data || ''
        }).finally(() => {
          this.set_bill_generate_type_loading = false
        }) 
      },
      legalAuditUserChange(data) {
        this.person_list.some((item) => {
          if (data === item.id) {
            return this.edit_contract.legal_audit_user = item.account
          }
        })
      },
      init() {
        this.edit_contract = this.new_contract;
        this.setFillUser(this.cur_customer);
        this.setApplyUser(this.cur_customer);
      },
      edit(contract) {
        this.config.modal = true;
        if (contract) {
          this.loading = true;
          ContractUtil.getDetail(contract.id).then((data) => {
            this.handleContractStocks(data.contract.contract_stocks);
            if (!data.contract.consume_schedule) {// 每月消耗
              data.contract.consume_schedule = this.$util.clone(this.new_contract.consume_schedule)
            }
            this.$set(this, 'edit_contract', data.contract);
            data.contract.consume_schedule && data.contract.consume_schedule.start_date && (this.edit_contract.has_consume_schedule = true)
            this.initEditor();
          }).catch(() => {
            this.$Message.error('获取数据失败, 请重试!');
            this.config.modal = false;
          }).finally(() => {
            this.loading = false;
          });
        } else {
          
          this.$set(this, 'edit_contract', this.$util.clone(this.new_contract));
          this.initEditor();
        }
      },
      initEditor() {
        // 在编辑新的contract时, 禁止执行部分watch事件
        this.init_editor = true;
        setTimeout(() => {
          this.init_editor = false;
        }, 500);
      },
      getFillTime(edit_contract) {
        const time = edit_contract.created_at || new Date();
        return moment(time).format('YYYY-MM-DD');
      },
      setApplyUser(customer) {
        this.edit_contract.apply_user_id = customer.id;
        this.edit_contract.apply_user = customer.account;
        //自动设置团队为经办人的团队
        if (customer.root_team_id) {
          this.edit_contract.team_id = customer.root_team_id;
        }
        document.body.click();
      },
      searchFillUser() {
        this.$util.ajax.get(this.$util.api.query_customer_name, {
          params: {
            search: this.search_fill_user_text
          }
        }).then((response) => {
          return response.data;
        }).then((res) => {
          this.search_fill_user_result = [];
          if (res.code === 1) {
            const data = res.data;
            data.forEach((customer) => {
              this.search_fill_user_result.push(customer);
            })
          } else {
            this.$Modal.error({
              title: '错误',
              content: res.msg
            });
          }
        }).catch((e) => {
          console.log(e);
        });
      },
      setFillUser(customer) {
        this.edit_contract.fill_user_id = customer.id;
        this.edit_contract.fill_user = customer.account;
      },
      addContractStock() {
        this.edit_contract.contract_stocks.push(this.$util.clone(this.new_contract_stock));
      },
      deleteContractStock(contract_stock, index) {
        this.$Modal.confirm({
          title: '提示',
          content: '你确认要删除吗?',
          onOk: () => {
            if (contract_stock.id) {
              this.$util.ajax.post(this.$util.api.delete_contract_stock, {
                id: contract_stock.id
              }).then((response) => {
                return response.data;
              }).then((data) => {
                console.log(data);
                if (data.code === 1) {
                  this.edit_contract.contract_stocks.splice(index, 1);
                  this.$Message.success('删除成功!');
                } else {
                  this.$Modal.error({
                    title: '提示',
                    content: data.msg
                  })
                }
              }).catch((e) => {
                console.log(e);
                this.$Modal.error({
                  title: '提示',
                  content: '删除失败'
                })
              });
            } else {
              this.edit_contract.contract_stocks.splice(index, 1);
            }
          }
        });
      },
      isLastContractStock(index) {
        return index === this.edit_contract.contract_stocks.length - 1;
      },
      getContractStock(id) {
        return this.stocks_hash[id] || {};
      },
      calcContractStockPrice(contract_stock) {
        if (!this.$util.isNumber(contract_stock.qty)) {
          return;
        }
        if (!this.$util.isNumber(contract_stock.unit_price)) {
          return;
        }
        let unit_price = contract_stock.unit_price || 0;
        let qty = contract_stock.qty || 0;
        contract_stock.unit_price = unit_price = math.round(unit_price, 3);
        contract_stock.qty = qty = math.round(qty);
        contract_stock.total_price = math.eval(`${unit_price} * ${qty}`).toFixed(2);
      },
      setStockTotalPriceToContractTotalPrice() {
        this.edit_contract.total_price = this.getContractStockTotalPrice(this.edit_contract);
      },
      queryStock() {
        if (!this.search_stock_loading) {
          this.search_stock_loading = true;
          this.$util.ajax.get(this.$util.api.query_stock, {
            params: {
              search: this.search_stock_text,
              page: 1,
              per_page: 10
            }
          }).then((response) => {
            return response.data;
          }).then((res) => {
            this.search_stock_loading = false;
            this.search_stock_results = [];
            if (res.code === 1) {
              const data = res.data;
              data.items.forEach((item) => {
                if (!item.del) {
                  this.search_stock_results.push(item);
                  this.stocks_hash[item.id] = item;
                }
              });
              // status: 1
              // console.log('this.search_stock_results',this.search_stock_results)
              if (this.search_stock_results.length === 0) {
                this.$Message.warning('未搜索到相关存货');
              }
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.search_stock_loading = false;
            console.log(e);
          });
        }
      },
      setContractStock(contract_stock, stock) {
        this.stocks_hash[stock.id] = stock;
        contract_stock.stock_id = stock.id;
        document.body.click();
      },
      searchPayeeCompanyPerson() {
        this.$refs.personSelector.search(this.edit_contract.payee_company);
      },
      searchPayeeCompany() {
        this.$refs.payeeCompanySelector.search(this.edit_contract.payee_company);
      },
      setPayeeCompany(company) {
        this.edit_contract.payee_company = company.name;
        this.edit_contract.payee_company_id = company.id;
        if (company.company_type > -1) {
          this.edit_contract.payee_company_type = company.company_type;
          if (company.company_type === 0 && company.id_number) {
            this.edit_contract.payee_id_number = company.id_number;
          }
        }
        document.body.click();
      },
      getContractType(id) {
        return this.contract_type_hash[id] || {};
      },
      setContractType(contract, type) {
        contract.contract_type_id = type.id;
        document.body.click();
      },
      setLinkContract(index, contract) {
        this.edit_contract.link_contracts.splice(index, 1, contract);
      },
      delLinkContract(index) {
        this.edit_contract.link_contracts.splice(index, 1);
      },
      getContractStockTotalPrice() {
        let total = 0;
        this.edit_contract.contract_stocks.forEach((stock) => {
          if (this.$util.isNumber(stock.total_price)) {
            total = math.eval(`${total} + ${stock.total_price}`);
          }
        });
        return total.toFixed(2);
      },
      formatContractNumbers() {
        this.edit_contract.total_price = math.eval(this.edit_contract.total_price || 0).toFixed(2);
        this.edit_contract.contract_stocks.forEach((stock) => {
          stock.qty = math.eval(stock.qty || 0).toFixed(0);
          stock.unit_price = math.eval(stock.unit_price || 0).toFixed(2);
          stock.total_price = math.eval(stock.total_price || 0).toFixed(2);
        });
      },
      checkValid() {
        let err_msg = '';
        try {
          if (!this.edit_contract.contract_type_id) {
            err_msg += '<p>请选择[合同类型]</p>';
          }
          if (!this.edit_contract.apply_user_id) {
            err_msg += '<p>请指定[申请人]</p>';
          }
          if (!this.edit_contract.legal_audit_user_id) {
            err_msg += '<p>请指定[法务审批人]</p>';
          }
          if (!this.edit_contract.company_id) {
            err_msg += '<p>请选择[公司]</p>';
          }
          if (!this.edit_contract.team_id) {
            err_msg += '<p>请选择[团队]</p>';
          }
          if (!this.edit_contract.contract_type_id) {
            err_msg += '<p>请选择[合同类型]</p>';
          }
          if (!this.edit_contract.name) {
            err_msg += '<p>[合同名称]不能为空</p>';
          }
          if (this.edit_contract.payee_company_type === 0) {
            if (!this.edit_contract.payee_company) {
              err_msg += '<p>[个人姓名]不能为空</p>';
            }
            if (!this.edit_contract.payee_id_number) {
              err_msg += '<p>[个人证件号]不能为空</p>';
            }
            if (this.edit_contract.payee_id_number.length >= 15 && !this.$util.IDCheck(this.edit_contract.payee_id_number)) {
              err_msg += '<p>[个人身份证号码]填写有误</p>';
            }
          } else {
            if (!this.edit_contract.payee_company) {
              err_msg += '<p>[公司名称]不能为空</p>';
            }
          }
          if (!this.$util.isNumber(this.edit_contract.total_price)) {
            err_msg += '<p>请输入正确的[合同总价]</p>';
          }
          if (this.edit_contract.contract_stocks.length) {
            this.edit_contract.contract_stocks.forEach((cs, index) => {
              if (!cs.stock_id) {
                err_msg += `<p>存货${index + 1}: 请选择存货</p>`;
              }
              if (!this.$util.isNumber(cs.qty)) {
                err_msg += `<p>存货${index + 1}: 请输入正确的[数量]</p>`;
              } else if (math.eval(`${cs.qty} <= 0`)) {
                err_msg += `<p>存货${index + 1}: [数量]不能为0</p>`;
              }
              if (!this.$util.isNumber(cs.unit_price)) {
                err_msg += `<p>存货${index + 1}: 请输入正确的[单价]</p>`;
              } else if (math.eval(`${cs.unit_price} <= 0`)) {
                err_msg += `<p>存货${index + 1}: [单价]不能为0</p>`;
              }
              if (!this.$util.isNumber(cs.total_price)) {
                err_msg += `<p>存货${index + 1}: 请输入正确的[总价]</p>`;
              } else if (math.eval(`${cs.total_price} <= 0`)) {
                err_msg += `<p>存货${index + 1}: [总价]不能为0</p>`;
              }
              if (this.edit_contract.bill_type === 'OutSourcing' && !cs.stock_in_type) {
                err_msg += `<p>存货${index + 1}: 请选择[入库类型]</p>`;
              }
            });
          }
          this.formatContractNumbers();
          const contract_total = this.edit_contract.total_price;
          const stock_total = this.getContractStockTotalPrice(this.edit_contract);
          if (math.eval(`${contract_total} < ${stock_total}`)) {
            err_msg += '<p>[合同总价]不能小于存货总价</p>';
          }
          if (math.eval(`${contract_total} >= 100000`) && this.edit_contract.bfiles.length === 0) {
            err_msg += '<p>[合同总价]大于10万, 请上传相关附件!</p>';
          }
          if (err_msg) {
            this.$Modal.error({
              title: '错误提示',
              content: err_msg
            });
            this.config.loading = false;
            setTimeout(() => {
              this.config.loading = true;
            }, 500);
            return false;
          }
          return true;
        } catch (e) {
          err_msg += `<p>${e.message}</p>`;
          this.$Modal.error({
            title: '错误提示',
            content: err_msg
          });
          this.config.loading = false;
          setTimeout(() => {
            this.config.loading = true;
          }, 500);
          return false;
        }
      },
      setContractOK() {
        if (!this.edit_contract.total_price) {
          this.edit_contract.total_price = 0;
        }
        if (this.checkValid()) {
          const edit_contract = this.$util.clone(this.edit_contract)
          if (!edit_contract.has_consume_schedule) {
            delete edit_contract.consume_schedule
          }
          if (!this.checkDis) {
            delete edit_contract.per_month_price
            delete edit_contract.has_consume_schedule
            delete edit_contract.consume_schedule
          }
          // 'self_submit'===edit_contract.bill_generate_type
          if ('self_submit' !== this.edit_contract.bill_generate_type) { // 账单生成方式如果是非手动成成就没有bill_provider 字段
            delete this.edit_contract.bill_provider
          }
          delete edit_contract.has_consume_schedule
          this.$util.ajax.post(this.$util.api.update_contract, this.edit_contract).then((response) => {
            return response.data;
          }).then((data) => {
            if (data.code === 1) {
              this.config.modal = false;
              //this.handleContractStocks(data.contract.contract_stocks);
              this.$emit('on-update', data.contract);
              this.$Message.success('保存成功!');
            } else {
              this.config.loading = false;
              setTimeout(() => {
                this.config.loading = true;
              }, 500);
              this.$Modal.error({
                title: '保存失败',
                content: data.msg
              })
            }
          }).catch((e) => {
            this.config.loading = false;
            setTimeout(() => {
              this.config.loading = true;
            }, 500);
            this.$Message.error('保存失败: ' + e);
          });
        }
      },
      handleContractStocks(contract_stocks) {
        contract_stocks.forEach((cs) => {
          cs.unit_price = cs.unit_price * 1;
          this.stocks_hash[cs.stock.id] = cs.stock;
        });
      },
      attachmentUploaded(bfile) {
        this.edit_contract.bfiles.push(bfile);
      },
      storeFile(contract) {
        this.store_file_config.modal = true;
        this.loading = true;
        ContractUtil.getDetail(contract.id).then((data) => {
          this.$set(this, 'edit_contract', data.contract);
        }).catch(() => {
          this.$Message.error('获取数据失败, 请重试!');
          this.store_file_config.modal = false;
        }).finally(() => {
          this.loading = false;
        });
      },
      storeFileOK() {
        this.$util.ajax.post(this.$util.api.update_contract_files, this.edit_contract).then((response) => {
          return response.data;
        }).then((data) => {
          if (data.code === 1) {
            this.store_file_config.modal = false;
            this.$Message.success('保存成功!');
          } else {
            this.store_file_config.loading = false;
            setTimeout(() => {
              this.store_file_config.loading = true;
            }, 500);
            this.$Modal.error({
              title: '保存失败',
              content: data.msg
            })
          }
        }).catch((e) => {
          this.store_file_config.loading = false;
          setTimeout(() => {
            this.store_file_config.loading = true;
          }, 500);
          this.$Message.error('保存失败: ' + e);
        });
      },
      fileUploaded(file) {
        this.edit_contract.files.push(file);
      },
      confirmDeleteFile(bfile) {
        this.$Modal.confirm({
          title: '删除确认',
          content: `你确定要删除 ${bfile.name} 吗?`,
          onOk:() => {
            this.$util.ajax.post(this.$util.api.delete_contract_file, {
              bfile_id: bfile.id,
              contract_id: this.edit_contract.id
            }).then((response) => {
              return response.data;
            }).then((data) => {
              if (data.code === 1) {
                this.$util.removeArrayItem(this.edit_contract.files, bfile);
              } else {
                this.$Modal.error({
                  title: '提示',
                  content: data.msg
                })
              }
            }).catch((e) => {
              console.log(e);
              this.$Message.error(e.message);
            });
          }
        });
      }
    }
  }
</script>
